import { YesNoUnknown } from "@nkr/enums/yes-no-unknown";

export interface INewDonorRecipientBaseData { 
    alias: string,
    mrn: string,
    gender: string,
    dateOfBirth: string,
    email: string,
    phoneNumber: string,
    firstName: string,
    lastName: string,
    bloodType: string,
    hasNutcracker: YesNoUnknown,
    address: string,
    city: string,
    state: string,
    postalCode: string,
    shipTypingSwabs: number,
    sendSelfRegistrationInvite: number,
    medicalRecordId: number
}